import { argon2id } from "hash-wasm";
import type { RegistrationChallenge } from "../../lib/types";

export function decodeBase64Url(value: string): Uint8Array {
  const padded = value.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(value.length / 4) * 4, "=");
  const binary = atob(padded);
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
}

export function proofPayload(challengeId: string, handle: string, nonce: string): string {
  return `ctfonlyfans-chat-v1:${challengeId}:${handle.toLowerCase()}:${nonce}`;
}

export function meetsTarget(digest: Uint8Array, targetBits: number): boolean {
  if (!Number.isInteger(targetBits) || targetBits < 0 || targetBits > digest.length * 8) return false;
  const fullBytes = Math.floor(targetBits / 8);
  for (let index = 0; index < fullBytes; index += 1) if (digest[index] !== 0) return false;
  const remaining = targetBits % 8;
  return remaining === 0 || (digest[fullBytes] ?? 0) >> (8 - remaining) === 0;
}

export function formatProofHashRate(attempts: number, elapsedMs: number): string {
  if (!Number.isFinite(attempts) || !Number.isFinite(elapsedMs) || attempts <= 0 || elapsedMs <= 0) return "—";
  const hashesPerSecond = attempts * 1_000 / elapsedMs;
  const maximumFractionDigits = hashesPerSecond < 10 ? 1 : 0;
  return `${new Intl.NumberFormat("en-US", { maximumFractionDigits }).format(hashesPerSecond)} hashes/s`;
}

export async function computeProofHash(challenge: RegistrationChallenge, handle: string, nonce: string): Promise<Uint8Array> {
  if (challenge.algorithm !== "argon2id-v19") throw new Error("Unsupported browser-check algorithm");
  return argon2id({
    password: proofPayload(challenge.id, handle, nonce),
    salt: decodeBase64Url(challenge.salt),
    iterations: challenge.iterations,
    memorySize: challenge.memoryKiB,
    parallelism: challenge.parallelism,
    hashLength: challenge.hashLength,
    outputType: "binary",
  });
}
